'use client';

import { ReactNode } from 'react';
import { ErrorBoundary } from './ErrorBoundary';

/**
 * Client-side Error Boundary wrapper for Server Components
 * Use this in server component layouts to add error boundaries
 */
export function ClientErrorBoundary({ children }: { children: ReactNode }) {
  return <ErrorBoundary>{children}</ErrorBoundary>;
}
